module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"reviews_count":"レビュー","product_score":"評価"}}')
  delete Component.options._Ctor
}
